import { useTheme } from '@automata/mui-theme';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import NotesOutlinedIcon from '@mui/icons-material/NotesOutlined';
import Box from '@mui/material/Box';
import MuiTab from '@mui/material/Tab';
import MuiTabs from '@mui/material/Tabs';
import * as React from 'react';
import { ReactElement, useCallback } from 'react';

import { TabId } from '../../types';

export const tabs = [
  {
    id: 'build',
    label: 'Build',
    icon: <AccountTreeOutlinedIcon />,
  },
  {
    id: 'preview',
    label: 'Preview',
    icon: <NotesOutlinedIcon />,
  },
] satisfies Array<{
  id: TabId;
  label: string;
  icon: ReactElement;
}>;

export type Props = {
  activeTabId: TabId;
  onChangeTab: (tabId: TabId) => void;
};

const BuildPreviewTabs = ({ activeTabId, onChangeTab }: Props) => {
  const theme = useTheme();

  const handleChangeTab = useCallback(
    (_: unknown, tabId: TabId) => {
      onChangeTab(tabId);
    },
    [onChangeTab]
  );

  return (
    <Box color={theme.palette.text.primary}>
      <MuiTabs
        value={activeTabId}
        onChange={handleChangeTab}
        aria-label="build/preview tabs"
        indicatorColor="secondary"
        textColor="inherit"
        sx={{
          '& button': { minHeight: 0, pt: 1.5 },
        }}
      >
        {tabs.map((tab) => (
          <MuiTab
            key={tab.id}
            id={`build-preview-tab-${tab.id}`}
            label={tab.label}
            icon={tab.icon}
            iconPosition="start"
            aria-controls={`build-preview-tabpanel-${tab.id}`}
            value={tab.id}
          />
        ))}
      </MuiTabs>
    </Box>
  );
};

export default BuildPreviewTabs;
